/* ==========================================================================
   Aarefa Abaya Interactive Behaviors
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Scroll Reveal Observer (with Reduced Motion detection)
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion) {
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach(el => observer.observe(el));
  } else {
    document.querySelectorAll('.reveal-on-scroll').forEach(el => el.classList.add('is-revealed'));
  }

  // 2. Mobile Menu Drawer
  const mobileMenuToggle = document.querySelector('.mobile-menu-trigger');
  const mobileDrawer = document.querySelector('#mobile-menu-drawer');
  const mobileDrawerClose = document.querySelector('#mobile-menu-close');

  if (mobileMenuToggle && mobileDrawer) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileDrawerClose && mobileDrawer) {
    mobileDrawerClose.addEventListener('click', () => {
      mobileDrawer.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // 3. Product Gallery Thumbnail Switching
  const thumbs = document.querySelectorAll('.product-gallery-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.getAttribute('data-full-src');
        if (newSrc) {
          mainImg.setAttribute('src', newSrc);
        }
      });
    });
  }

  // 4. Product Variant Buttons (Size / Color selection)
  const variantBlocks = document.querySelectorAll('.product-option-block');
  const stickyAtcBar = document.querySelector('.sticky-atc-bar');
  const mainAtcBtn = document.querySelector('.btn-add-to-cart');

  let selectedOptions = {};

  variantBlocks.forEach(block => {
    const optionName = block.getAttribute('data-option-name');
    const buttons = block.querySelectorAll('.variant-btn');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        const val = btn.getAttribute('data-value');
        selectedOptions[optionName] = val;

        const valDisplay = block.querySelector('.selected-value');
        if (valDisplay) valDisplay.textContent = val;

        // Check if all options are chosen
        checkVariantReady();
      });
    });
  });

  function checkVariantReady() {
    const totalOptions = variantBlocks.length;
    const selectedCount = Object.keys(selectedOptions).length;
    if (selectedCount >= totalOptions) {
      if (mainAtcBtn) {
        mainAtcBtn.disabled = false;
        mainAtcBtn.textContent = 'Add to Cart';
      }
      if (stickyAtcBar) {
        const stickyBtn = stickyAtcBar.querySelector('button');
        if (stickyBtn) stickyBtn.disabled = false;
      }
    }
  }

  // 5. Mobile Sticky Add to Cart visibility on scroll
  if (mainAtcBtn && stickyAtcBar) {
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && window.scrollY > 300) {
          stickyAtcBar.classList.add('active');
        } else {
          stickyAtcBar.classList.remove('active');
        }
      });
    }, { threshold: 0 });

    atcObserver.observe(mainAtcBtn);
  }

  // 6. Accordions (Fabric, Care, Delivery/Returns)
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isOpen = content.style.display === 'block';

      // Toggle current
      if (isOpen) {
        content.style.display = 'none';
        header.setAttribute('aria-expanded', 'false');
        header.querySelector('.accordion-icon').textContent = '+';
      } else {
        content.style.display = 'block';
        header.setAttribute('aria-expanded', 'true');
        header.querySelector('.accordion-icon').textContent = '−';
      }
    });
  });

  // 7. Size Guide Modal
  const sizeGuideOpen = document.querySelectorAll('.js-open-size-guide');
  const sizeGuideModal = document.querySelector('#size-guide-modal');
  const sizeGuideClose = document.querySelectorAll('.js-close-size-guide');

  sizeGuideOpen.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (sizeGuideModal) sizeGuideModal.classList.add('active');
    });
  });

  sizeGuideClose.forEach(btn => {
    btn.addEventListener('click', () => {
      if (sizeGuideModal) sizeGuideModal.classList.remove('active');
    });
  });

  if (sizeGuideModal) {
    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target === sizeGuideModal) {
        sizeGuideModal.classList.remove('active');
      }
    });
  }
});
